<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Add Variant</h5>
                </div>
                <div class="card-body">
                    <div class="row product-adding">
                        <div class="col-xl-7">
                            <div class="col-xl-5">
                                <div class="add-product">
                                    <div class="row">
                                        <div class="col-xl-9 xl-50 col-sm-6 col-9">
                                            <img [src]="url[0].img"  alt="test" class="img-fluid image_zoom_1">
                                        </div>
                                        <div class="col-xl-3 xl-50 col-sm-6 col-3">
                                            <ul class="file-upload-product">
                                                <li *ngFor="let item of url; let i=index">
                                                    <div class="box-input-file">
                                                        <input class="upload" type="file" (change)="readUrl($event,i)">
                                                        <img class="imgUpload" alt="" [src]="item.img">
                                                    </div>
                                                    <div>
                                                        <img class="imgUpload" [src]="item.del" (click)="deletImg($event,item)"> 
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <form class="needs-validation" [formGroup]="variantForm" novalidate>
                                <div class="add-product-form">
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">Quantity
                                            :</label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01" (keypress)="allowOnlyNumbers($event)"
                                            type="number" min="1" max="9999" type="text" [formControl]="variantForm.controls['qte']" required>
                                        <div *ngIf="variantForm.controls.qte.touched && variantForm.controls.qte.errors?.required" class="text text-danger">
                                            Stock
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">price
                                            :</label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="variantForm.controls['price']"   (keypress)="allowOnlyNumbersForPrice($event)" required>
                                        <div *ngIf="variantForm.controls.price.touched && variantForm.controls.price.errors?.required"
                                            class="text text-danger">
                                            price
                                        </div>
                                    </div>


                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">description variant
                                            :</label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="variantForm.controls['description']" required>
                                        <div *ngIf="variantForm.controls.description.touched && variantForm.controls.description.errors?.required"
                                            class="text text-danger">
                                            description  is required.
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">description variant es
                                            :</label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="variantForm.controls['descriptiones']" required>
                                        <div *ngIf="variantForm.controls.descriptiones.touched && variantForm.controls.descriptiones.errors?.required"
                                            class="text text-danger">
                                            description  is required.
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">description variant fr
                                            :</label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="variantForm.controls['descriptionfr']" required>
                                        <div *ngIf="variantForm.controls.descriptionfr.touched && variantForm.controls.descriptionfr.errors?.required"
                                            class="text text-danger">
                                            description  is required.
                                        </div>
                                    </div>
                                    <div class="form-group row" *ngIf="IsColorEnabled">
                                        <label for="exampleFormControlSelect1" class="col-xl-3 col-sm-4 mb-0">Select
                                            color
                                            :<span *ngIf="variantForm.get('color').errors?.colorForbidden" class="text text-danger">
                                                *
                                            </span></label>
                                            <select [formControl]="variantForm.controls['color']"  class="form-control digits col-xl-8 col-sm-7"
                                               >
                                                <option *ngFor="let color of colorList"
                                                    [ngValue]="color">{{color.description}}</option>
                                            </select>
                                       

                                    </div>
                                
                                    <div class="form-group row">
                                        <label for="exampleFormControlSelect1" class="col-xl-3 col-sm-4 mb-0">Select
                                            size:<span *ngIf="variantForm.get('size').errors?.sizeForbidden" class="text text-danger">*
                                            </span>
                                           </label>
                                        <select [formControl]="variantForm.controls['size']" class="form-control digits col-xl-8 col-sm-7"
                                            id="exampleFormControlSelect1">
                                            <option *ngFor="let size of sizeList" [ngValue]="size.idSize">{{size.size1}}
                                            </option>
                                    
                                        </select>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-sm-4 mb-0">New</label>
                                        <div class="checkbox checkbox-primary col-md-7">
                                            <input id="checkbox-primary-1" type="checkbox"
                                            [formControl]="variantForm.controls['new']" data-original-title="" title="">
                                            <label for="checkbox-primary-1">Include</label>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div class="modal-footer">

                                <button type="button" class="btn btn-primary" (click)="saveVariant(variantForm)"
                                   >Add Variant</button>
                                <div name="buttonSpace"></div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="product-buttons col-sm-8 offset-xl-3 offset-sm-4">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="batchDelete" class="category-table custom-datatable">
                        <div class="table-responsive">
                            <ng2-smart-table [settings]="settings" [source]="Source"
                                    (createConfirm)="addRecord($event)"  (editConfirm)="updateRecord($event)" (deleteConfirm)="deleteRecord($event)">
                                </ng2-smart-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->